import React from "react";

const ConfirmationPending = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
        fill="#D9822F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0157 5.55542C9.55206 5.55542 9.1811 5.94047 9.19838 6.40382L9.35683 10.6538C9.37012 11.0103 9.66297 11.2924 10.0197 11.2924C10.3769 11.2924 10.67 11.0096 10.6826 10.6526L10.8332 6.4023C10.8495 5.93951 10.4788 5.55542 10.0157 5.55542Z"
        fill="white"
      />
      <path
        d="M9.20459 13.6333C9.20459 13.1871 9.56634 12.8253 10.0126 12.8253C10.4588 12.8253 10.8206 13.1871 10.8206 13.6333C10.8206 14.0795 10.4588 14.4413 10.0126 14.4413C9.56634 14.4413 9.20459 14.0795 9.20459 13.6333Z"
        fill="white"
      />
    </svg>
  );
};

export default ConfirmationPending;
